import TimeReport from "../../../core/model2/time-report/time-report";
// @ts-ignore
import Request from 'gd-request';
import Resources from "../../../core/resources/resources";
import {TimeReportType} from "../../../views/reports/time-reports/@types";

export function getTimeSpentValue(m:any, type:any) {
    let val;
    switch (type) {
        case TimeReportType.REPORTED:
            val = m.reportedMinutes;
            break;
        case TimeReportType.REPORTED_GUESSTIMATES:
        default:
            val =  m.reportedMinutes + m.estimatedMinutes;
            break;
    }

    if (val < 0) val = 0;
    return val;
}


export async function loadTimeReportData(startDate:Moment, endDate:Moment, viewType: any, taskTypeIds?:ID[]):Promise<any> {

    const payload = {
        organizationId  : gd.companyId,
        startDate       : startDate.format('YYYY-MM-DD'),
        endDate         : endDate.format('YYYY-MM-DD'),
        reportedOnly    : viewType === TimeReportType.REPORTED, //this.viewType === VIEW_TYPE_REPORTED,
        taskTypeIds     : taskTypeIds
    };

    const response = await new Request(null, 'POST', '/analytics/time-spending/company/new', payload).promise();

    if (!response || !response.reports || !response.tasks) {
        return 'no-data'
    }

    const resources = new Resources()
    resources.resetTasks(response.tasks)

    // PATCH // patch data a grouped but we want id
    _.map(response.reports, (timeReport)=>{
        timeReport['id'] = gd.utils.generateUUID()
    })
    resources.resetTimeReports(response.reports)

    await resources.loadMissingData({taskProjectWithParents: true})

    // console.log("RESOURCE loaded")


    const reports = response.reports

    // NOW process finance
    if (gd.company.trackInternalCosts() || gd.company.trackExternalCosts()) {
        _.map(reports, (timeReport)=>{
            const timeReportModel = new TimeReport(timeReport)
            timeReport.internalCost = timeReportModel.costInternal
            timeReport.externalCost = timeReportModel.costExternal
        })
    }

    _.map(reports, (report)=>{

        const task = resources.tasks?.get(report.taskId)

        let noAcceess = false

        const p = gd.session.projects.get(task.projectId);
        if (!p) {
            console.warn('p_not_found', task.projectId, task);
        }

        if (!p || !p.access) {
            noAcceess = true;
        }

        const u = gd.session.users.get(report.userId)
        if (!u) {
            console.warn('u_not_found', report.userId);

        }

        report.projectId    = task.projectId
        report.project      = p!.toJSON();
        report.projectWithNoAccess = noAcceess;
        report.user = u?.toJSON();
        report.user.initials = u?.initials;
        report.task = task;
        report.date = moment(report.date);
        report.timeSpent = getTimeSpentValue(report, viewType);
    })

    return reports

}
